/*
 * Todanua — Fase 5. O carrinho.
 *
 * Este arquivo faz UMA coisa: adicionar uma peça ao carrinho sem fechar a
 * gaveta (item H3). Só isso.
 *
 * 🔴 As três barras de progresso — frete grátis (H1), desconto progressivo
 * (H2) e escada de brindes (G10) — NÃO estão aqui, e essa é a decisão de
 * projeto mais importante da fase. Elas são Liquid puro, renderizado pelo
 * servidor, porque o `cart.js` do Dawn já troca o `.drawer__inner` inteiro a
 * cada mudança de quantidade e o `cart-drawer.js` troca o `#CartDrawer` inteiro
 * a cada adição. Uma conta em JavaScript aqui seria uma SEGUNDA verdade sobre o
 * subtotal — e a primeira a divergir no dia em que entrasse um desconto
 * automático ou um item de brinde. Zero bytes gastos, zero risco de divergir.
 *
 * 🔴 Nada de biblioteca. `fetch` e `DOMParser` são do navegador.
 */
(function () {
  'use strict';

  /* 🔴 Fase 6 — trava contra carregar duas vezes.
   *
   * Os ouvintes daqui são delegados no documento. Se um dia este arquivo
   * chegar por dois caminhos (a gaveta e uma seção que também o inclua), cada
   * clique seria contado DUAS vezes e o carrinho receberia a peça em dobro —
   * um defeito que só aparece no pedido. Três linhas para nunca acontecer. */
  if (window.tdCartAdd) return;

  /*
   * Reaproveita o próprio mecanismo do Dawn em vez de escrever um segundo.
   * `CartDrawer.renderContents` já sabe quais seções trocar e já abre a gaveta
   * — é o mesmo caminho que o formulário da página de produto usa. Escrever o
   * meu duplicaria a lista de seletores, e dois lugares para a mesma lista é o
   * começo de um bug silencioso.
   *
   * ⚠️ O que ele NÃO faz (e a revisão pegou): ele tira `is-empty` do
   * `.drawer__inner`, mas não do `<cart-drawer>`. Quem tira essa é o `finally`
   * do `product-form.js`. Está reproduzido abaixo.
   */
  function tdCartAddItems(items, trigger) {
    const drawer = document.querySelector('cart-drawer');
    const routes = window.routes || {};
    const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];

    // 🔴 Guardar para onde o foco volta ANTES da requisição, como o
    // `product-form.js` do Dawn faz. Sem isto, ao fechar a gaveta o Dawn
    // devolveria o foco a um elemento que já foi trocado pela re-renderização
    // — e quem navega por teclado ficaria com o foco no nada.
    if (drawer && typeof drawer.setActiveElement === 'function') {
      const back = trigger && trigger.isConnected ? trigger : document.getElementById('cart-icon-bubble');
      if (back) drawer.setActiveElement(back);
    }

    const body = {
      items: items,
      sections: sections,
      sections_url: window.location.pathname,
    };

    return fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        // A API do carrinho responde 4xx com um corpo que TEM `status`. Sem
        // esta checagem, uma peça que esgotou entre o carregamento da página e
        // o toque falharia em silêncio — foi exatamente o defeito que a revisão
        // da Fase 3 achou no cross-sell.
        if (data.status) {
          throw new Error(data.description || data.message || '');
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          // 🔴 Publicar o evento ANTES de desenhar, exatamente na ordem do
          // `product-form.js` do Dawn. Eu tinha deixado de publicar para
          // economizar uma requisição, e a revisão mostrou o preço disso: na
          // PÁGINA do carrinho, os itens e os totais ficariam no valor antigo
          // depois de uma adição feita pela gaveta. Custa uma requisição;
          // pagar em requisição é melhor que pagar em subtotal errado.
          /* 🔴 DEFEITO DA FASE 5, achado pela revisão da Fase 6: eu escrevia
             `window.PUB_SUB_EVENTS`, e esse objeto NÃO existe em `window`.
             O Dawn o declara com `const` no `constants.js`, e `const` no
             escopo global entra no ambiente léxico, não no objeto global —
             ao contrário de `function publish()`, que entra. Resultado: a
             condição era sempre falsa e o evento `cartUpdate` NUNCA era
             publicado. Ou seja, a correção que a revisão da Fase 5 pediu (a
             página do carrinho ficar com o subtotal velho depois de uma
             adição pela gaveta) estava escrita e nunca rodou.
             Agora é o identificador nu, com guarda por `typeof` — o mesmo
             padrão que o `td-pdp.js` já usava para o `variantChange`. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'td-cart',
              productVariantId: String(items[0] && items[0].id),
              cartData: data,
            });
          }
          drawer.renderContents(data);
          // O Dawn faz esta limpeza no `finally` do formulário de produto, e
          // ela não está dentro do `renderContents`: sem ela, a PRIMEIRA
          // adição num carrinho vazio deixa o `<cart-drawer>` com a classe
          // `is-empty` e a gaveta abre mostrando o estado de carrinho vazio.
          drawer.classList.remove('is-empty');
        } else {
          // Sem gaveta (carrinho em modo "notificação"), o caminho honesto é
          // levar a cliente ao carrinho, e não fingir que algo aconteceu.
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return data;
      });
  }

  /* Fase 6 — a mesma função passou a aceitar VÁRIOS itens de uma vez, porque o
     montador de conjunto (K1) e a recompra de básicos (K6) adicionam três ou
     quatro peças num toque só. Uma requisição por peça abriria e fecharia a
     gaveta três vezes e faria o subtotal pular no meio do caminho.

     `tdCartAdd` continua existindo com a assinatura antiga: o `td-collection.js`
     (compra rápida) e o botão do cross-sell chamam assim, e mudar a assinatura
     deles seria trocar um risco real por nenhum ganho. */
  function tdCartAdd(variantId, quantity, trigger) {
    return tdCartAddItems([{ id: Number(variantId), quantity: quantity || 1 }], trigger);
  }

  // Exposto para o `td-collection.js` (a compra rápida da vitrine) e para o
  // `td-plus.js` (K1 e K6) usarem o mesmo caminho. Um único lugar que adiciona
  // ao carrinho neste tema.
  window.tdCartAdd = tdCartAdd;
  window.tdCartAddItems = tdCartAddItems;

  function showError(scope, message) {
    const box = scope && scope.querySelector('.td-recs__error');
    if (!box) return;
    box.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
    box.hidden = false;
  }

  /*
   * Delegação no documento, e não um ouvinte por botão. A gaveta é
   * re-renderizada a cada mudança do carrinho: um ouvinte preso ao botão
   * morreria junto com ele, e a partir da segunda adição nada aconteceria —
   * sem um único erro no console. É a mesma lição do mega menu da Fase 4.
   */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-td-add]');
    if (!button) return;
    if (button.disabled) return;

    event.preventDefault();
    /* A caixa de erro pode estar em dois lugares hoje: na sugestao da gaveta
       (H3, Fase 5) e no card do ponto da foto editorial (C7, Fase 6). Procuro
       os dois pelo mesmo seletor em vez de escrever um segundo caminho de
       adicionar ao carrinho — que continua sendo um so neste tema. */
    const scope = button.closest('.td-recs, .td-look__card');
    const errorBox = scope && scope.querySelector('.td-recs__error');
    if (errorBox) errorBox.hidden = true;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    tdCartAdd(button.getAttribute('data-td-add'), 1, button).catch(function (error) {
      showError(scope, error && error.message);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  });
})();
